import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, Text, View, Platform, ActivityIndicator, TouchableOpacity } from 'react-native';
import { Screen, Button, Input } from '../components';
import { HomePetsList } from '../containers';
import PetController from '../controllers/petController';
import AuthController from '../controllers/authController';
import UserController from '../controllers/userController';
import { useNavigate } from 'react-router-dom';

class SettingsChangePasswordScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      has_password: false
    }

    this.update_confirm_password = this.update_confirm_password.bind(this);
    this.update_password = this.update_password.bind(this);
    this.password_valid = this.password_valid.bind(this);
    this.change_password = this.change_password.bind(this);
  }

  async componentDidMount() {
    let user = await AuthController.getUser();

    if(user) {
      this.setState({
        has_password: user.has_password
      })
    }
  }

  update_password(password) {
    let form_valid = this.password_valid(password, this.state.confirm_password);

    this.setState({
      password,
      form_valid
    })
  }

  update_confirm_password(confirm_password) {
    let form_valid = this.password_valid(this.state.password, confirm_password);

    this.setState({
      confirm_password,
      form_valid
    })
  }

  async change_password() {
    let password = this.state.password;

    let response = await UserController.changePassword({password});

    console.log('response', response)

    if(response.success) {
      this.goBack();
    } else {
      this.setState({
        change_password_error: response.error
      });
    }
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  password_valid(password, confirm_password) {
    // TODO: validate format of password

    if(password.length < 3) { return false; }

    if(password !== confirm_password) { return false; }

    return true;
  }

  render() {

    let loading = this.state.loading;
    let inactive = !this.state.form_valid;
    let change_password_error = this.state.change_password_error;

    return (
      <Screen navigation={this.props.navigation} title={`${this.state.has_password ? 'Change' : 'Set'} Password`} style={{ backgroundColor: 'white' }}>
        <View style={{ padding: 20 }}>
            <Input label='Password'
              style={{  }}
              onChangeText={this.update_password}/>

            <Input label='Confirm Password'
              style={{  }}
              onChangeText={this.update_confirm_password}/>

            {change_password_error ? <Text style={styles.error_message}>{change_password_error}</Text> : null}

            <Button title={`${this.state.has_password ? 'Change' : 'Set'} Password`}
              inactive={inactive}
              loading={loading}
              style={{ marginTop: 15 }}
              onPress={this.change_password}/>
        </View>
      </Screen>
    );
  }

}

function SettingsChangePasswordScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <SettingsChangePasswordScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SettingsChangePasswordScreen_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({
  error_message: { color: 'red' }
});

export default SettingsChangePasswordScreen
